/* @ngInject */
export default function detailsMediaPageBootstrap($stateProvider, MPA_PAGES) {
  $stateProvider.state(MPA_PAGES.DETAILS_MEDIA.name, {
    url: MPA_PAGES.DETAILS_MEDIA.url,
    // custom props
    title: 'MENU_MEDIA',
    weight: 3,
    componentAllowanceId: 'mediaExtension',
    visible: true,
    // custom props end
    component: 'detailsMediaPageComponent',
    resolve: {
      /* @ngInject */
      interaction: (businessLogService, itemGroup) =>
        businessLogService.generate({
          event: businessLogService.events.DETAILS_MEDIA,
          data: {
            product: itemGroup.getUsageInfo()
          }
        })
    }
  })
}
